import { BlogSection } from '@/types/blog';

export const demokratieSpracheSection: BlogSection = {
  id: 'demokratie-sprache',
  title: 'Demokratie beginnt in der Sprache',
  content: `
    <p>
      Hannah Arendt erinnerte uns daran, dass es ohne Wahrheit keine Freiheit gibt. Erich Fromm warnte vor dem Wunsch, die Last der Freiheit gegen einfache Antworten einzutauschen. Demokratie stirbt nicht nur durch Zensur, sondern auch durch Sprachverrohung. Wenn Sprache nur noch als Waffe genutzt wird, stirbt der Dialog. Wir brauchen eine neue Klarheit, die bei uns selbst beginnt.
    </p>
  `
};
